module.exports = __webpack_public_path__ + "img/restRoom.de3119a8.png";